import { createSlice } from '@reduxjs/toolkit';

import { SlicePayload, UntypedObject } from '@/types';

export type PrimeurState = {
  primeurUser?: UntypedObject;
  hashUser?: string;
}

export const initialState: PrimeurState = {
  primeurUser: undefined,
  hashUser: undefined
};

const primeur = createSlice({
  name: 'primeur',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setPrimeurUser: (_state, _action: SlicePayload<{ content: UntypedObject }>) => {
    },

    setPrimeurUserSuccess: (state, action: SlicePayload<{ primeurUser: UntypedObject }>) => {
      const { primeurUser } = action.payload;
      state.primeurUser = primeurUser;
      state.primeurUser.alerts = primeurUser?.alerts || [];
    },

    setHashUser: (state, action: SlicePayload<{ hash: string }>) => {
      state.hashUser = action.payload.hash;
    },

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    addAlert: (_state, _action: SlicePayload<{ alerts: string[], name: string, isAllChecked: boolean, storeId: string }>) => {
    },

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    primeurOnSubmit: (_state, _action: SlicePayload<{ t, content }>) => {
    },

    primeurOnUpdate: (
      _state,
      _action: SlicePayload<{
        t: (_k: string) => string,
        idPrimeurUser: boolean,
        email: string,
        tel: string,
        countryPhone: string,
        warnByEmail: boolean,
        warnBySms: boolean
      }>
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    ) => {
    },

    primeurClearUser: (state) => {
      state.primeurUser = undefined;
      state.hashUser = undefined;
    }
  }
});

export const {
  setPrimeurUser, setPrimeurUserSuccess,
  setHashUser, addAlert,
  primeurOnSubmit, primeurOnUpdate, primeurClearUser
} = primeur.actions;

export default primeur.reducer;
